import "./firebase.js";
import "./app-check.js";
import { auth, signIn, signOut, onAuthChange } from "./auth.js";
import { renderDashboard } from "./pages/dashboard.js";
import { renderLanding } from "./pages/landing.js";
import { renderRolePicker } from "./pages/role-picker.js";
import { getRole } from "./role.js";
import { setUser, logNav } from "./debug-log.js";

const signInBtn  = document.getElementById("sign-in");
const signOutBtn = document.getElementById("sign-out");
const emailSpan  = document.getElementById("user-email");
const appEl      = document.getElementById("app");

let currentUser = null;
let currentRole = null;
let lastUid = null;

signInBtn.addEventListener("click", () =>
  signIn().catch((err) => alert("Pieteikšanās neizdevās: " + err.message)),
);
signOutBtn.addEventListener("click", () => signOut());

async function route() {
  if (!currentUser) {
    renderLanding(appEl);
    return;
  }
  const [, page, param1, param2, param3] = location.hash.split("/");
  logNav({ hash: location.hash, page, params: [param1, param2, param3] });
  if (page === "accept" || page === "accept-coparent") {
    const activeUser = currentUser;
    try {
      if (page === "accept") {
        const { renderAccept } = await import("./pages/accept.js");
        await renderAccept(appEl, param1);
      } else {
        const { renderAcceptCoParent } = await import("./pages/accept-coparent.js");
        await renderAcceptCoParent(appEl, param1);
      }
    } catch (err) {
      if (currentUser !== activeUser) return;
      console.error(err);
      appEl.innerHTML = `<p>Kļūda: ${err.message}</p>`;
    }
    return;
  }
  if (currentRole === null) {
    renderRolePicker(appEl, {
      onComplete(role) {
        currentRole = role;
        route();
      },
    });
    return;
  }
  const activeUser = currentUser;
  try {
    if (page === "parent" && param2 === "attempt") {
      const { renderAttemptDetail } = await import("./pages/attempt-detail.js");
      await renderAttemptDetail(appEl, param1, param3);
    } else if (page === "parent") {
      const { renderKidHistory } = await import("./pages/kid-history.js");
      await renderKidHistory(appEl, param1);
    } else if (page === "attempt") {
      if (currentRole === "parent") {
        location.hash = "";
        return;
      }
      const { renderAttempt } = await import("./pages/attempt.js");
      await renderAttempt(appEl, param1, param2);
    } else if (page === "pdf") {
      const { renderPdfView } = await import("./pages/pdf-view.js");
      await renderPdfView(appEl, param1, param2);
    } else if (page === "results") {
      const { renderResults } = await import("./pages/results.js");
      await renderResults(appEl, param1, param2, param3);
    } else if (currentRole === "parent") {
      const { renderParentDashboard } = await import("./pages/parent.js");
      await renderParentDashboard(appEl);
    } else {
      await renderDashboard(appEl);
    }
  } catch (err) {
    if (currentUser !== activeUser) return;
    console.error(err);
    appEl.textContent = `Kļūda: ${err.message}`;
  }
}

window.addEventListener("hashchange", route);

onAuthChange(async (user) => {
  // True only when a user signs in / the app opens with a persisted session —
  // NOT on later auth events (e.g. token refresh) for the same user.
  const isNewSignIn = !!user && user.uid !== lastUid;
  lastUid = user?.uid ?? null;
  currentUser = user;
  signInBtn.hidden  = !!user;
  signOutBtn.hidden = !user;
  emailSpan.textContent = user?.email ?? "";
  try {
    const role = user ? await getRole(user) : null;
    if (currentUser !== user || user !== auth.currentUser) return;
    currentRole = role;
    setUser(user ? { uid: user.uid, email: user.email, role } : null);
    if (user && role !== null) {
      const { doc, updateDoc, serverTimestamp } = await import("firebase/firestore");
      const { db } = await import("./firestore.js");
      updateDoc(doc(db, "users", user.uid), {
        lastLogin: serverTimestamp(),
      }).catch((err) => {
        setTimeout(() => {
          updateDoc(doc(db, "users", user.uid), {
            lastLogin: serverTimestamp(),
          }).catch((e) => console.warn("Retry update lastLogin failed:", e));
        }, 1000);
      });
    }
  } catch (err) {
    console.error("getRole failed:", err);
    if (currentUser !== user || user !== auth.currentUser) return;
    currentRole = null;
    setUser(user ? { uid: user.uid, email: user.email, role: null } : null);
  }
  // On a fresh app open / login, always land on the dashboard instead of
  // restoring a stale in-app deep link (e.g. #/attempt/2024/4) left in the URL.
  // Invitation links (#/accept, #/accept-coparent) are preserved so join flows work.
  // Scoped to the initial sign-in so token refreshes don't yank an active user away.
  if (isNewSignIn) {
    const target = location.hash.split("/")[1];
    if (target && target !== "accept" && target !== "accept-coparent") {
      history.replaceState(null, "", location.pathname + location.search);
    }
  }
  route();
});
